import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-510eb5d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-page" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = {
  key: 0,
  class: "resource"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "resource"
}
const _hoisted_6 = ["onClick"]

import { ref, onMounted } from 'vue'
import Text from '@/components/text'
import AppForm from './components/app-form.vue'
import { CODE_ENUM } from '@/common'
import { queryAppList } from '@/api'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const tableData = ref([])
const tableLoading = ref(false)

const tableColumn: any = [
  {
    prop: 'appName',
    label: '应用',
    width: '130px',
  },
  {
    prop: 'directoryName',
    label: '目录',
    width: '130px',
  },
  {
    prop: 'menuName',
    label: '菜单',
    width: '150px',
  },
  {
    prop: 'buttonName',
    label: '按钮',
    width: '150px',
  },
]

const fetchList = async () => {
  const res: any = await queryAppList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    const result = res.data.reduce((mo: any, el: any) => {
      const { directories } = el

      mo.push({
        appName: el.name,
      })

      const directoryList = (directories || []).map((directory: any) => {
        const { name, menues } = directory
        mo.push({
          directoryName: name,
        })
        const list = menues.map((item: any) => {
          const menueResult = (item.children || []).reduce(
            (m: any, e: any, index: number) => {
              m.push({
                menuName: index === 0 ? item.name : '',
                resourceName: e.name,
                desc: e.describe,
                id: e.id,
                buttonName: e.buttonName,
              })
              return m
            },
            []
          )
          return menueResult
        })
        mo = mo.concat(list.flat(Infinity))
      })
      return mo
    }, [])

    tableData.value = result
  }
}

onMounted(() => {
  fetchList()
})

const appConf = ref({
  visible: false,
  data: {},
})

const toAppForm = (data: any) => {
  appConf.value = {
    visible: true,
    data,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: true,
          data: tableData.value,
          class: "ws_mt24"
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, { description: "暂无数据" })
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableColumn, (item, index) => {
              return _createVNode(_component_el_table_column, _mergeProps({ key: index }, {
            ...item,
          }), null, 16)
            }), 64)),
            _createVNode(_component_el_table_column, {
              label: "资源名称",
              width: "180px"
            }, {
              default: _withCtx((scoped) => [
                (scoped.row.id)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (
                  toAppForm({
                    name: scoped.row.resourceName,
                    id: scoped.row.id,
                  })
                ),
                        class: "icon-edit ws_mr4"
                      }, null, 8, _hoisted_4),
                      _createVNode(_unref(Text), {
                        content: scoped.row.resourceName
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scoped.row.resourceName), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "资源描述" }, {
              default: _withCtx((scoped) => [
                (scoped.row.id)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (
                  toAppForm({
                    desc: scoped.row.desc,
                    id: scoped.row.id,
                  })
                ),
                        class: "icon-edit ws_mr4"
                      }, null, 8, _hoisted_6),
                      _createVNode(_unref(Text), {
                        content: scoped.row.desc
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scoped.row.desc || '-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ])
      ])
    ]),
    _createVNode(AppForm, {
      visible: appConf.value.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((appConf.value.visible) = $event)),
      data: appConf.value.data,
      onOnSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})